import { render, staticRenderFns } from "./GoogleTOS.vue?vue&type=template&id=f73c2922&scoped=true"
import script from "./GoogleTOS.vue?vue&type=script&lang=js"
export * from "./GoogleTOS.vue?vue&type=script&lang=js"
import style0 from "./GoogleTOS.vue?vue&type=style&index=0&id=f73c2922&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f73c2922",
  null
  
)

export default component.exports